export enum NetworkTagBackgroundColor {
  N3 = '#00E599',
  TN3 = '#00E599',
  LEGACY = '#DEDEDE',
  X = '#0168FF',
}
